import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Session} from '@app/app.session';
import {LOGGER} from '@app/services/logger.service';
import {UIService} from '@app/services/ui.service';

@Component({
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit, OnDestroy {
  public errorCode: number;
  public errorDetails: string;

  constructor(private readonly route: ActivatedRoute,
              private readonly session: Session,
              private readonly ui: UIService) {
    this.errorCode = route.snapshot.data['errorCode'] || this.session.lastErrorCode || -1;
  }

  ngOnInit(): void {
    this.treatError();
  }

  ngOnDestroy(): void {
    this.session.lastErrorCode = null;
    this.session.lastErrorDetails = null;
  }


  treatError() {
    if (this.errorCode === 404) {
      this.errorDetails = '/' + this.route.snapshot.url.join('/');
    } else if (this.errorCode === 401) {
      this.errorDetails = this.session.lastErrorDetails;
    }

    LOGGER.error(`Error ${this.errorCode} : ${this.errorDetails}`);
  }
}
